import React, {useContext, useState, useEffect} from "react"
import { Link } from "gatsby"
import { UserContext } from '../../utils/usermanagement'
import RelatedArticles from "../RelatedArticles/RelatedArticles"
import WelcomeBanner from "./WelcomeBanner/WelcomeBanner"
import FunLearning from "./FunLearning/FunLearning"
import PhoneSmartCards from "./PhoneSmartCards/PhoneSmartCards"
import GetStarted from "./GetStarted/GetStarted"
import CollectStickers from "./CollectStickers/CollectStickers"
import WinDraw from "./WinDraw/WinDraw"
import Partnership from "./Partnership/Partnership"
import KeepTabs from "./KeepTabs/KeepTabs"
import WinDrawLoggedIn from "./WinDrawLoggedIn/WinDrawLoggedIn"
import CollectStickersLoggedIn from "./CollectStickersLoggedIn/CollectStickersLoggedIn"
import EEBanner from "../EEContent/EEContentType/EEBanner"

import stickerslike from "./../../images/stickerslike.png"
// import sticker from "./../../images/stickers_phonesmartsupport.png"
import "./BeanoPageBody.scss";
import SocialShare from "../SocialShare/SocialShare"
import BannerImage from './../../images/banner-beano.png'
import logo from './../../images/PS-licence.png'
import HeartIcon from "./../../images/hash-icon.png"
import StaticVideo from "../Video/StaticVideo"
import BeanoKeepTabs from "./BeanoKeepTabs/BeanoKeepTabs"
import BeanoGoingSolo from "./BeanoGoingSolo/BeanoGoingSolo"
import BeanoAppsDowntime from "./BeanoAppsDowntime/BeanoAppsDowntime"
import HeartSquare from "./../../images/Heart-Sticker-x2.png"
import Card1 from "./../../images/beanocard-1.png"
import Card2 from "./../../images/Child-Learning-Screens-x2.png"
import partnerImage from './../../images/IM-logo.svg'
import BannerTop from './../../images/Get-Phonesmart-Graphic-x2.png'


const BeanoPageBody = ({data, engagement}) => {
	const [userState, userDispatch] = useContext(UserContext);					/* eslint-disable no-unused-vars */
	const [isLoggedIn, setisLoggedIn] = useState(false);
	let items = [];
	items[0] = data.get_phonesmart_banner.document.data

	useEffect(() => {
		if(userState?.cognito_user?.attributes) {
			setisLoggedIn(true)
		} else {
			setisLoggedIn(false)
		}
	}, [userState])

	return (
		<>
			<section className="video-wrapper beano-banner">
				<div className="poster-image">
					<div className="image-wrapper">
						<img src={BannerImage} className="" alt="Banner Image"/>
					</div>
				</div>
			</section>
			<div className="beano">
				<section className="parent-get-started">
					{/* <WelcomeBanner /> */}
					<section className="welcome-banner">
						<img src={logo} alt="PhoneSmart Licence" className="phonesmartimg"/>
						<div className="baner-content logged-state-logout loggedout">
							<h1>Get PhoneSmart with<br />EE and Beano</h1>
							{/* <h3>Watch as Dennis learns how to stay safe and be kind online with EE’s PhoneSmart Licence</h3> */}
							<p>Getting your child their first phone can be a worrying time for parents. To help, EE has teamed up with Beano to provide tips and advice on how, with the help of the EE PhoneSmart Licence, you can help your kids to learn to stay safe and be kind online, giving you peace of mind	&#9825;.</p>
							<Link to={`/register/`} className="btn btn-primary"
							data-analytics='{"event":"signUp", "eventCategory":"Beano - Engagement", "eventAction":"CTA Click - Sign up", "eventLabel":"Sign up to get your kid PhoneSmart"}'>Sign up to get your kid PhoneSmart</Link>
							{/* <p className="network">It’s available to any kids on any network</p> */}
							<img src={HeartIcon} alt="sticker Heart" className="lol-img"/>
						</div>
					</section>
					<div className="parent-container">
						<BeanoKeepTabs />
					</div>
				</section>
				<section>
					<BeanoGoingSolo/>
					<BeanoAppsDowntime/>
					
				</section>

				<section className="home-page-get-them-started">
						<div className="container">
							<div className="row sticker-win logged-in cards-beano">
								<div className="col-12">
									<div className="text-center card-text">
										<img src={HeartSquare} alt="Icon" className="heart-sqaure" />
										<h2 className="h1"><span>EE PhoneSmart Licence</span></h2>
									</div>
									<div className="row">
										<div className="col-12 col-md-6">
											<div className="collectstickers-loggedin logged-in sticker">			
												<p>EE PhoneSmart Licence is free for everyone, not just EE customers. The online course gives kids the tools and confidence to use their phone safely and responsibly.</p>
												<div className="beano-card-img">
													<img src={Card1} className="big-reveal" alt="phonesmart card"/>
												</div>
											</div>
										</div>
										<div className="col-12 col-md-6 mt-md-xs">
											<div className="sticker logged-in">
												<p>EE PhoneSmart is full of epic interactive stories, fun quizzes and stickers to collect as kids learn how to stay safe and kind online. It only takes about an hour to do.</p>
												<div className="beano-card-img">
													<img src={Card2} className="big-reveal" alt="big Reveal"/>
												</div>
											</div>
										</div>
									</div>
									<div className="text-center"><Link to={`/register/`} className="btn btn-secondary morelink" data-analytics='{"event":"genericClick", "eventCategory":"Beano - Engagement", "eventAction":"CTA Click", "eventLabel":"Sign up to get your kid PhoneSmart now"}'>Sign up to get your kid PhoneSmart now</Link></div>
									{/* <img src={sticker} className="phonesmartsticker" alt="phonesmart sticker"/> */}
								</div>
							</div>
						</div>
					</section>


				<div className="partnership beano-part">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<h2>Developed in partnership</h2>
								<p>The EE Beano comic and PhoneSmart has been developed with experts from Internet Matters to make sure they prepare kids appropriately for the phone world.</p>
								<div className="partners">
								<div className="partner-logo">
									<a target="_blank" href="https://www.internetmatters.org/?utm_source=Beano_landing&utm_medium=referral&utm_campaign=phonesmart&utm_content=_EE_beano_landing_page" data-analytics='{"event":"outbound", "eventCategory":"Beano - Engagement", "eventAction":"outbound Click", "eventLabel":"Internet matters logo"}'><img src={partnerImage} alt="Internet Matters" /></a>
								</div>
								</div>
								<div className="text-center mt-4">
									<Link to={`/about/`} className="btn btn-secondary" data-analytics='{"event":"genericClick", "eventCategory":"Beano - Engagement", "eventAction":"CTA Click", "eventLabel":"Why Online Safety Matters"}'>Why Online Safety Matters</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<section className="beano-footer-banner">
					<img src={BannerTop} alt="banner image" className="banner-top" />
					<EEBanner items={items} engagement={engagement} />
				</section>
			</div>
		</>
	)
	
}

export default BeanoPageBody
